import { render, staticRenderFns } from "./first-info-layer.vue?vue&type=template&id=2c4fb0e5"
import script from "./first-info-layer.vue?vue&type=script&lang=js"
export * from "./first-info-layer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports